// 博士会api
 import baseRequest2 from '../baseApi2';
 import request from 'superagent';
 
 
 export const fetchassocation = () => (
     baseRequest2(
         request.get('/platform/page/data')
             .query({requestUrl: '/paddledoctor'})
             .query(window.location.search.slice(1))
     )
 );
 